import { ApiError } from "../../../types/api-error";

export type GetUsersDataResponse = {
  result: boolean;
  error_code: ApiError;
  payload: GetUsersDataPayload;
  errors_debug: string[];
};

export type GetUsersDataPayload = {
  dane_operator: OperatorData;
  dane_wykonawca: SubcontractorData;
  dane_klient: ClientData;
};

export type OperatorData = {
  id_operator: string;
  imie: string;
  nazwisko: string;
  email: string;
  telefon: string;
};
export type SubcontractorData = {
  id_wykonawca: string;
  nazwa: string;
  telefon: string;
  email: string;
  typ_wykonawcy: number;
  adres: UserDataAddress;
};
export type ClientData = {
  id_klient: string;
  nazwa: string;
  nip: string;
  weryfikacja: VerificationEnum;
  telefon: string;
  email: string;
  info_dodatkowe: string;
  aktywny: boolean;
  liczba_zamowien: number;
  adres_klient: UserDataAddress;
};
export type UserDataAddress = {
  id_adres?: string;
  kod_pocztowy: string;
  miejscowosc_poczty: string;
  miejscowosc: string;
  ulica: string;
  numer_budynku: string;
  numer_lokalu: string;
  wojewodztwo: string;
  szerokosc_geograficzna: number;
  dlugosc_geograficzna: number;
};
export enum VerificationEnum {
  unverified = 0,
  positiveVerification = 1,
  negativeVerification = 2,
}
